import React, {Component, Fragment} from 'react'
import {observer} from 'mobx-react'

// import Checkbox from 'lib/control/Checkbox';
import Checkbox from './DependentCheckbox'
import SpanLink from 'lib/control/SpanLink'

import Icon from 'lib/struct/icon/Icon';

import styles from './Tree.less'

const {
    'tree': tree_class,
    'node': node_class,
    'node__arrow': arrow_class,
    'node__label': label_class,
    'node__children': children_class,

    "categories-tree__checkbox": checkbox_class,
    "categories-tree__checkbox_disabled": checkbox_disabled_class,
    "categories-tree__node-block": node_block_class,
    "categories-tree__mass-check-block": mass_check_block_class,
    "categories-tree__mass-check-button": mass_check_all_button_class,
} = styles

@observer export default class Tree extends Component {
    constructor(props) {
        super(props)

        const {nodes} = this.props

        this.state = {
            collapsed_map: {},
            has_children: {},
        }

        nodes.forEach(node => {
            this.state.collapsed_map[node.id] = true

            if (node.parent_id > 0) {
                this.state.has_children[node.parent_id] = true
            }
        })
    }

    render() {
        /** @type {Array<Category>} */
        const nodes = this.props.nodes
        /** @type {CatalogEntity} */
        const entity = this.props.entity
        /** @type {ProfileSettingsEditState} */
        const state = this.props.state

        const {renderNode} = this.props

        let skip_depth = null

        return (
            <div className={tree_class}>
                {
                    nodes.map(node => {
                        const node_id = node.id
                        const depth = node.depth || 0

                        if (skip_depth !== null) {
                            if (depth < skip_depth) {
                                skip_depth = null
                            } else {
                                return
                            }
                        }

                        if (skip_depth === null) {
                            if (this.isCollapsed(node_id)) {
                                skip_depth = depth + 1
                            }
                        }


                        return (
                            <div className={node_class} key={node_id} style={{marginLeft: 15 * depth}}>
                                <div className={label_class}>
                                    {
                                        this.hasChildren(node_id) ? (
                                            (
                                                <div className={arrow_class}
                                                     onClick={() => this.toggleCollapse(node_id)}>
                                                    {::this.isCollapsed(node_id) ? (
                                                        <Icon name="rarr"/>
                                                    ) : (
                                                        <Icon name="darr"/>
                                                    )}
                                                </div>
                                            )
                                        ) : (null)
                                    }

                                    <div className={node_block_class}>
                                        {
                                            renderNode ? (
                                                renderNode(node, entity, state)
                                            ) : (
                                                this.renderNode(node, entity, state)
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    /**
     * @param {Category} node
     * @param {CatalogEntity} entity
     * @param {ProfileSettingsEditState} form_state
     * @return {*}
     */
    renderNode = (node, entity, form_state) => {
        const {node_type} = this.props

        const node_id = node.id
        const {disabled_category_ids, disabled_label_title, withoutSelection, nodeMarkRenderer} = this.props

        const is_disabled = disabled_category_ids && disabled_category_ids.has && disabled_category_ids.has(node_id)

        const node_checkbox_classes = [checkbox_class]
        if (is_disabled) {
            node_checkbox_classes.push(checkbox_disabled_class)
        }

        return withoutSelection ? (
            <Fragment>
                {node.name}
            </Fragment>
        ) : (
            <Fragment>
                <Checkbox
                    className={node_checkbox_classes.join(' ')}
                    checked={entity.isSelected(node_id)}
                    onChange={e => entity.toggle(node_id, e.target.checked)}
                    title={is_disabled && disabled_label_title ? disabled_label_title : ''}
                    state={form_state}
                >
                    {
                        node_type === 'category' ? (
                            <span><Icon name={node.is_static ? 'folder' : 'funnel'}/></span>
                        ) : (null)
                    }
                    {node.name}

                    {
                        nodeMarkRenderer ? (nodeMarkRenderer(node)) : (null)
                    }
                </Checkbox>

                {
                    this.hasChildren(node_id) ? (
                        <span className={mass_check_block_class}>
							Подкатегории: <SpanLink
                            onClick={() => this.toggleNodeChildren(node_id, true)}
                            className={mass_check_all_button_class}
                        >все</SpanLink> / <SpanLink
                            onClick={() => this.toggleNodeChildren(node_id, false)}
                            className={mass_check_all_button_class}
                        >ни одной</SpanLink>
						</span>
                    ) : (null)
                }
            </Fragment>
        )
    }


    isCollapsed(id) {
        const {
            collapsed_map
        } = this.state

        return collapsed_map[id] || false
    }

    toggleCollapse(id) {
        const {
            collapsed_map
        } = this.state

        this.setState({
            collapsed_map: {
                ...collapsed_map,
                [id]: !collapsed_map[id]
            }
        })
    }

    hasChildren(id) {
        const {has_children} = this.state

        return !!has_children[id]
    }

    toggleNodeChildren(node_id, toggle) {
        /** @type {Array<Category>} */
        const nodes = this.props.nodes

        /** @type {CatalogEntity} */
        const entity = this.props.entity

        let updated_depth = null

        for (const i in nodes) {
            const node = nodes[i]

            if (updated_depth === null) {
                if (node.id == node_id) {
                    updated_depth = 1 + node.depth
                }

                continue
            }

            const depth = node.depth || 0

            if (depth >= updated_depth) {
                entity.toggle(node.id, toggle)
            } else {
                return
            }
        }
    }
}
